import React from "react";
import { X, AlertCircle } from "lucide-react";

export default function ConfirmationModal({
  isOpen,
  onClose,
  onCancel,
  onConfirm,
  title,
  message,
  confirmText = "Konfirmasi",
  confirmColor = "teal",
  type = "info", // info, danger, success
  isLoading = false,
}) {
  if (!isOpen) return null;

  const getColors = () => {
    switch (type) {
      case "danger":
        return {
          icon: "text-rose-600 bg-rose-50 ring-1 ring-rose-100",
          button: "bg-rose-600 hover:bg-rose-700 shadow-sm shadow-rose-600/20",
        };
      case "success":
        return {
          icon: "text-emerald-600 bg-emerald-50 ring-1 ring-emerald-100",
          button:
            "bg-emerald-600 hover:bg-emerald-700 shadow-sm shadow-emerald-600/20",
        };
      default:
        return {
          icon: "text-teal-600 bg-teal-50 ring-1 ring-teal-100",
          button: "bg-teal-600 hover:bg-teal-700 shadow-sm shadow-teal-600/20",
        };
    }
  };

  const colors = getColors();
  const handleCancel = onClose || onCancel;

  return (
    <div
      onClick={handleCancel}
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4 modal-backdrop-enter">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl ring-1 ring-slate-200/70 w-full max-w-sm flex flex-col shadow-2xl overflow-hidden modal-panel-enter">
        <div className="p-6 text-center">
          <div
            className={`w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 ${colors.icon}`}>
            <AlertCircle className="w-7 h-7" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900 tracking-tight mb-2">
            {title}
          </h3>
          <p className="text-sm text-slate-500">{message}</p>
        </div>

        <div className="flex items-center gap-3 px-6 pb-6">
          <button
            onClick={handleCancel}
            disabled={isLoading}
            className="flex-1 px-4 py-2 bg-white ring-1 ring-slate-200 rounded-lg text-slate-700 hover:bg-slate-50 font-medium text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            Batal
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`flex-1 px-4 py-2 text-white rounded-lg font-medium text-sm transition-colors ${colors.button} disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2`}>
            {isLoading ? (
              <>
                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Memproses...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
